var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 8",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.807 8a1.06 1.06 0 01-.777-.316L.53 4.986a.746.746 0 01-.165-.28.655.655 0 01-.022-.31.705.705 0 01.124-.293.876.876 0 01.253-.232c.102-.063.218-.11.342-.136a1.186 1.186 0 01.74.083c.11.053.206.124.284.207L3.73 5.8 7.864.375A.993.993 0 018.47.02c.252-.047.516-.011.736.1.457.232.597.724.312 1.098L4.635 7.624a.912.912 0 01-.335.267c-.137.065-.29.102-.449.108h-.044z"
  })));
}
export default SvgCheckmark;